<script>
import { formatTimestamp, formatISOString, capitalize, fiftyStates } from 'utils';

export default {
  name: 'BaseForm',

  data() {
    return {
      formatTimestamp,
      formatISOString,
      capitalize,
      fiftyStates,
      syncing: false,
      validForm: true,
      rules: {
        required: value => !!value || 'This field is required!',
        roles(value) {
          return value.length > 0 || 'You must select at least one role.';
        },
        url(value) {
          if (!value) {
            return true;
          }
          try {
            new URL(value);
            return true;
          } catch (e) {
            return 'Invalid URL';
          }
        },
      },
    };
  },

  computed: {
    invalidForm() {
      return !this.validForm || !this.validate();
    },
  },

  methods: {
    validate() {
      return this.$refs.form.validate();
    },

    closeModal() {
      this.$emit('close-modal');
    },

    clearChanges() {
      this.$emit('clear-changes');
    },
  },
};
</script>
